const ToggleSwitch = ({
  options = ["global", "artist"],
  labels = ["Global", "Artist"],
  value,
  onChange,
}) => {
  const isSecondSelected = value === options[1];

  return (
    <div className="flex items-center justify-start">
      <button
        type="button"
        onClick={() =>
          onChange(isSecondSelected ? options[0] : options[1])
        }
        className={`relative inline-flex h-10 w-32 rounded-full transition-all duration-300 ${
          isSecondSelected
            ? "bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 shadow-lg"
            : "bg-gray-300"
        }`}
      >
        <span
          className={`absolute top-1 left-1 h-8 w-16 rounded-full bg-white shadow-md flex items-center justify-center text-xs font-semibold transition-transform duration-300 ${
            isSecondSelected ? "translate-x-14" : "translate-x-0"
          }`}
        >
          {isSecondSelected ? labels[1] : labels[0]}
        </span>
      </button>
    </div>
  );
};

export default ToggleSwitch;